import { useState, useEffect } from "react";
import apiClient from "../api-services/ApiClient";

function useEliteSubscriber() {
  const [isSubscribed, setIsSubscribed] = useState<boolean | null>(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const getActiveEliteSubscription = async () =>{
        try {
          const res: any = await apiClient.get(`get-active-elite-subscription`);
          if(res.data.status === 'ACTIVE')    
            setIsSubscribed(true);
          else
            setIsSubscribed(false);
        } catch (error) {
            setIsSubscribed(false);
        } finally {
        setLoading(false);
        }
      };

    getActiveEliteSubscription();
  }, []);

  return { isSubscribed, loading };
}

export default useEliteSubscriber;
